import React from 'react';

type Props = {
  loading: boolean;
};
export const EmptyState: React.FC<Props> = (props) => {
  const { loading } = props;
  if (loading) {
    return (
      <div className='p-4 mt-2 flex flex-col gap-2'>
        <p className='font-semibold leading-6 text-base'>
          Loading, please wait
        </p>
      </div>
    );
  }
  return (
    <div className='p-4 mt-2 flex flex-col gap-2'>
      <p className='font-semibold leading-6 text-base'>
        Sorry, We Couldn’t Find Any Results
      </p>
      <p className='text-gray-500 font-light text-base leading-6'>
        Try double checking your search for any typos or spelling errors - or
        try a different search term.
      </p>
    </div>
  );
};
